var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeatEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68.965 185.21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.167 -63.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1)",
    x: -90.132,
    y: -248.71,
    width: 21.167,
    height: 185.21,
    strokeWidth: 0.23665
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(-1)",
    x: -58.382,
    y: -248.71,
    width: 5.2917,
    height: 185.21,
    strokeWidth: 0.11832
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1)",
    cx: -31.75,
    cy: -134.94,
    r: 10.583,
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "scale(-1)",
    cx: -31.75,
    cy: -177.27,
    r: 10.583,
    strokeWidth: 0.26458
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatEnd);
export default __webpack_public_path__ + "static/media/repeatEnd.edbfdfcef0e54a720dcdb3747de1262e.svg";
export { ForwardRef as ReactComponent };